import api from "../global/Api";
import { ENDPOINTS } from "../global/ApiEndpoints";

export const getAllGestraPrices = async (page, size, searchString) => {
    const response = await api.get(`/${ENDPOINTS.GESTRA_PRICE_TABLE}`, {
        params: { page, size, search: searchString },
    });
    return response.data;
};

export const updateGestraPrice = async (id, body) => {
    const response = await api.put(`/${ENDPOINTS.GESTRA_PRICE_TABLE}/${id}`, body);
    return response.data;
};

export const getGestraPriceSourcePdf = async () => {
    const response = await api.get(`/${ENDPOINTS.GESTRA_PRICE_TABLE}/source`, {
        responseType: "blob",
    });
    return response.data;
};